import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "contact_Help",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12411",
			"data-name": "Path 12411",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12413",
			"data-name": "Path 12413",
			d: "M12,13.25V13a1.873,1.873,0,0,1,1.011-1.6A1.837,1.837,0,0,0,14,9.833a2,2,0,0,0-4,0",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12414",
			"data-name": "Path 12414",
			d: "M12,16a.25.25,0,1,0,.251.25A.249.249,0,0,0,12,16",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgContactHelp;
